import { REACT_QUERY_KEYS } from '@/constants'

import { notDispatchedShipmentOrderQueryTypes } from '../query-keys'

export type InvalidateShipmentOrdersParams = {
  tenantKey: string
  shippingDate: string
}

/** invalidate 対象とする未配車一覧系クエリの type 文字列（query-keys.ts の共有定義） */
const INVALIDATION_TARGET_TYPES: ReadonlySet<string> = new Set(
  notDispatchedShipmentOrderQueryTypes
)

/**
 * 未配車一覧系クエリのうち、指定したテナント・配送日のキャッシュを
 * invalidate対象に含めるべきqueryKeyかを判定する
 */
export const shouldInvalidateShipmentOrdersQueryKey = (
  queryKey: readonly unknown[],
  params: InvalidateShipmentOrdersParams
) => {
  const [scope, type, query] = queryKey

  if (scope !== REACT_QUERY_KEYS.VEHICLE_DISPATCH_BOARDS) {
    return false
  }

  if (typeof type !== 'string' || !INVALIDATION_TARGET_TYPES.has(type)) {
    return false
  }

  if (
    typeof query !== 'object' ||
    query === null ||
    !('tenantKey' in query) ||
    !('shippingDate' in query)
  ) {
    return false
  }

  const shipmentOrderQuery = query as InvalidateShipmentOrdersParams

  return (
    shipmentOrderQuery.tenantKey === params.tenantKey &&
    shipmentOrderQuery.shippingDate === params.shippingDate
  )
}
